import firebase from "firebase/compat/app";
import "firebase/compat/auth"; //for authentication
import "firebase/compat/storage"; //for storage
import "firebase/compat/database"; //for realtime
import "firebase/compat/firestore"; //for cloud firestore

const firebaseConfig = {
	apiKey: "AIzaSyDksBlPTdbN2MgJU_M7_yO8jWhPWXXNEvY",
	authDomain: "social-network-fe423.firebaseapp.com",
	projectId: "social-network-fe423",
	storageBucket: "social-network-fe423.appspot.com",
	messagingSenderId: "338608553418",
	appId: "1:338608553418:web:7083484ee0cbd10f236333",
	measurementId: "G-HNBYZ9M4QR",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
